/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  EmailBodyResponse,
  FileAsAStream,
  GetCommunicationAttachmentSignedUrlParams,
  GetEmailBodyParams,
  MassUpdateEmailsResponse,
  SignedUrlResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Retrieve an email body from the communications service.
 */
export const getEmailBody = (
  params: GetEmailBodyParams,
  options?: SecondParameter<typeof backofficeRequest<EmailBodyResponse>>,
) => {
  return backofficeRequest<EmailBodyResponse>(
    { url: `/communication/email-body`, method: "GET", params },
    options,
  )
}
/**
 * @summary Retrieve a signed url to download a communication attachment.
 */
export const getCommunicationAttachmentSignedUrl = (
  params: GetCommunicationAttachmentSignedUrlParams,
  options?: SecondParameter<typeof backofficeRequest<SignedUrlResponse>>,
) => {
  return backofficeRequest<SignedUrlResponse>(
    { url: `/communication/attachment/signed-url`, method: "GET", params },
    options,
  )
}
/**
 * @summary Updates emails based on the uploaded csv
 */
export const massUpdateEmails = (
  fileAsAStream: FileAsAStream,
  options?: SecondParameter<typeof backofficeRequest<MassUpdateEmailsResponse>>,
) => {
  const formData = new FormData()
  formData.append(`file`, fileAsAStream.file)

  return backofficeRequest<MassUpdateEmailsResponse>(
    {
      url: `/communication/mass-update-emails`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  )
}
export type GetEmailBodyResult = NonNullable<
  Awaited<ReturnType<typeof getEmailBody>>
>
export type GetCommunicationAttachmentSignedUrlResult = NonNullable<
  Awaited<ReturnType<typeof getCommunicationAttachmentSignedUrl>>
>
export type MassUpdateEmailsResult = NonNullable<
  Awaited<ReturnType<typeof massUpdateEmails>>
>
